<div
    class="absolute inset-0 w-full h-full opacity-5 pointer-events-none z-0"
    [style.background-image]="'url(' + watermark_path + ')'"
    style="background-repeat: no-repeat; background-position: center; background-size: cover;">
</div>